/*
 * LE DEPLIAGE DES APPS DANS LE MENU DES PARAMETRES : UNE SEULE APP OUVERTE, CELLE
 * DE L'ENTREE QUI L'EST.
 *
 * Avant, chaque clic sur une app la marquait « depliee pour toujours » : aller
 * sur Conversations laissait Consultations ouverte, puis Patients s'ajoutait, et
 * le rail devenait un escalier. Maintenant l'etat se DEDUIT de l'entree ouverte
 * (l'adresse mene) : plus rien a nettoyer quand on change de page, par clic OU
 * par le bouton Precedent.
 *
 * Le seul etat qui reste est `replieSur` : l'entree de menu sur laquelle
 * l'utilisateur a REPLIE son app en recliquant le parent. Il ne vaut que tant que
 * cette entree reste ouverte ; des qu'une autre l'est, `replieSur !== menuOuvert`
 * redevient vrai tout seul. Pas d'effet, pas de liste a purger.
 *
 * `menuOuvert` est `menuDemande` du hub, pas `activeMenuId` : c'est lui qui
 * ramene l'ancien sous-onglet Avance au parent, donc « Avance » compte comme le
 * parent (meme surlignage, meme repli), et il ignore le repli sur `dock` fait
 * pour un onglet disparu, qui n'est pas un choix de l'utilisateur.
 */

/** L'app est-elle depliee ? Seulement celle de l'entree ouverte, sauf si elle a ete repliee a la main. */
export function appDepliee({ appId, appOuverte, replieSur, menuOuvert }: {
  appId: string;
  /** L'app dont une entree est ouverte, ou `null` (Conversations, Dock...). */
  appOuverte: string | null;
  replieSur: string | null;
  menuOuvert: string;
}): boolean {
  return appId === appOuverte && replieSur !== menuOuvert;
}

/**
 * Le nouveau `replieSur` apres un clic sur `idClique`. Recliquer le PARENT d'une
 * app deja ouverte bascule : replie, puis redeplie. Tout autre clic (autre page,
 * autre app, entree fixe) l'efface : l'app qu'il ouvre se deplie, les autres se
 * replient d'elles-memes.
 */
export function replieApresClic({ idClique, parentId, replieSur, menuOuvert }: {
  idClique: string;
  /** L'entree parente de l'app cliquee (`app:<id>`). */
  parentId: string;
  replieSur: string | null;
  /** L'entree ouverte AVANT le clic. */
  menuOuvert: string;
}): string | null {
  if (idClique !== parentId || menuOuvert !== parentId) return null;
  return replieSur === parentId ? null : parentId;
}
